<template>
  <div class="total-item">
    <span class="label">神腦幣：</span>
    <span class="price">-{{ bonusPoint | dollar }}</span>
  </div>
</template>

<script>
import { dollar } from '@/helpers/format/dollar';
import { getState } from '@/helpers/vuex';

export default {
  name: 'bonus-point',
  filters: {
    dollar,
  },
  computed: {
    /** 神腦幣 */
    bonusPoint: getState('AmountDetail', 'bonusPoint'),
  },
};
</script>
